import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import PrivacyPolicy from "./sections/PrivacyPolicy";
export default function PrivacyPolicyPage() {
  return <>
      <Header />
      <PrivacyPolicy />
      <Footer />
    </>;
}